var render = function render(_c,_vm){return _c('div',{staticClass:"grid-view-aggregation__generic"},[_c('span',{staticClass:"grid-view-aggregation__generic-name"},[_vm._v(_vm._s(_vm.props.aggregationType.getShortName()))]),_vm._v(" "),_c('span',{staticClass:"grid-view-aggregation__generic-value",class:{
      'grid-view-aggregation__generic-value--loading': _vm.props.loading,
    }},[_vm._v(_vm._s(_vm.props.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }